module.exports = "{{#analyticsUrl}}html::after { content: url({{{.}}}); position: absolute; left: -999em; }{{/analyticsUrl}}\n"